/* ═══════════════════════════════════════
   KAZEHAUS — i18n.js
   EN / DE translation dictionary + engine
═══════════════════════════════════════ */

window.CARINA_I18N = {
  en: {
    // Header / nav
    cart: "Cart",
    sign_in: "Sign In",
    my_account: "My Account",
    sign_out: "Sign Out",
    search_placeholder: "Search rugs…",
    home: "Home",

    // Hero
    stat_models: "Rug Models",
    stat_satisfaction: "Satisfaction",
    stat_countries: "Countries",
    scroll: "scroll",

    // Collection grid (page 2)
    explore: "Explore",
    nav_by_room: "By Room",
    nav_by_theme: "By Theme",
    nav_best_sellers: "Best Sellers",
    nav_round_rugs: "Round Rugs",
    round_label: "Round",
    round_all: "All Round Rugs",
    shop_by_category: "Shop by <em>Category</em>",
    browse_sub: "Browse every room and theme — 500+ rugs waiting for you.",
    room_label: "Room",
    theme_label: "Theme",
    room_living: "Living Room",
    room_bedroom: "Bedroom",
    room_kids: "Kids Room",
    theme_sports: "Sports & Football",
    theme_cars: "Cars & Formula 1",
    theme_anime: "Anime",
    theme_space: "Space & Galaxy",
    theme_moody: "Moody & Aesthetic",
    theme_abstract: "Abstract & Modern",
    shop_now: "Shop now →",

    // Featured (page 3)
    featured: "Featured",
    picked_for_you: "Picked for <em>You</em>",
    curated_sub: "Curated pieces our customers love most this season.",

    // Product card
    add_to_cart: "Add to Cart",
    sold_out: "Sold Out",
    best_seller: "Best Seller",
    sale: "Sale",
    new_badge: "New",
    adding_dots: "Adding…",
    added_check: "Added ✓",
    error_word: "Error",

    // Homepage info (page 4)
    ship_free_title: "Free Worldwide Shipping",
    ship_free_sub: "No minimums. Every country.",
    ship_fast_title: "Fast Dispatch",
    ship_fast_sub: "Ships within 1–3 business days",
    ship_secure_title: "Secure &amp; Insured",
    ship_secure_sub: "Every order fully protected",
    ship_quality_title: "Premium Quality",
    ship_quality_sub: "Vibrant, fade-resistant prints",
    support: "Support",
    common_questions: "Common Questions",
    faq_q1: "How long does shipping take?",
    faq_a1: "Most orders are dispatched within 1–3 business days. International delivery typically takes 7–14 business days depending on your location. You'll receive a tracking link by email once shipped.",
    faq_q2: "Do you ship to my country?",
    faq_a2: "Yes — we ship to every country worldwide with no minimum order. Shipping is always free, no exceptions.",
    faq_q3: "Can I return a rug?",
    faq_a3: "We accept returns or refunds only in the case of a manufacturing or printing error. Contact us with photos within 48 hours of delivery.",
    faq_q4: "How do I track my order?",
    faq_a4: "Once dispatched you'll receive a tracking email. You can also click the \"Track Order\" button on this page and enter your order number.",
    faq_q5: "Do you make custom sizes?",
    faq_a5: "Yes. Contact us through the form below with your required dimensions and design preferences. We'll get back to you within 24 hours.",
    faq_q6: "What payment methods do you accept?",
    faq_a6: "We accept all major credit and debit cards (Visa, Mastercard), as well as digital wallets. All payments are processed securely.",
    get_in_touch: "Get in Touch",
    contact_us: "Contact <em>Us</em>",
    your_name: "Your name",
    your_email: "Your email",
    select_topic: "Select topic",
    order_question: "Order question",
    return_exchange: "Return / Exchange",
    custom_order: "Custom order",
    shipping_question: "Shipping question",
    other: "Other",
    your_message: "Your message…",
    send_message: "Send Message",
    thank_you_reply: "Thank you! We'll reply within 24 hours.",
    response_24h: "Response within 24 hours",

    // Side buttons
    my_cart: "My Cart",
    track_order: "Track Order",
    all_rugs: "All Rugs",

    // Track modal
    track_your_order: "Track Your Order",
    track_your_order_sub: "Enter your order details to check delivery status",
    order_number_ph: "Order number (e.g. KAZE-2025-0001)",
    email_address_ph: "Email address",
    need_help: "Need help?",
    contact_us_arrow: "Contact us →",

    // Cart drawer
    total: "Total",
    free_worldwide_shipping: "Free worldwide shipping",
    checkout_arrow: "Checkout →",
    added_to_cart: "Added to cart!",
    might_also_like: "You might also like:",
    finding_recommendations: "Finding recommendations…",
    view_cart_arrow: "View Cart →",

    // Footer
    footer_tagline: "Handcrafted &amp; modern rugs.<br>Free worldwide shipping.",
    about_us: "About Us",
    contact: "Contact",
    privacy_policy: "Privacy Policy",
    terms_of_service: "Terms of Service",
    refund_policy: "Refund Policy",
    shipping_policy: "Shipping Policy",
    seo_title: "Modern Rugs & Runner Rugs, Made for Your Home",
    seo_p1: "KazeHaus designs modern area rugs, runner rugs and washable art rugs that bring character to every room — living rooms, bedrooms, kitchens, hallways and kids' rooms. From abstract and vintage patterns to anime and pop-culture designs, every rug is made to order and crafted with non-slip backing and easy-care, washable materials.",
    seo_p2: "We ship worldwide — to the United States, Canada, the United Kingdom, Germany, Spain and beyond — with free delivery in just 3–5 business days. Whether you're looking for an 8x10 area rug, a narrow runner rug for your hallway, or a statement piece for your gaming room, KazeHaus has a design made for you.",
    distance_sales: "Distance Sales Agreement",
    secure_payment_with: "Secure Payment",
    all_rights_reserved: "All rights reserved.",
    free_shipping: "Free Shipping",
    secure_payment: "Secure Payment",

    // Product page
    trust_free_shipping: "✦ Free worldwide shipping",
    trust_ships_days: "✦ Ships in 1–3 days",
    buy_now: "Buy Now",
    meta_material: "Material",
    meta_size: "Size",
    meta_origin: "Origin",
    meta_care: "Care",
    pcs_material_title: "Material &amp; Quality",
    pcs_material_text: "<strong>Material:</strong> Premium polyester microfiber with photo-realistic digital print — colors stay vibrant with no fading over time.",
    pcs_surface_text: "<strong>Surface:</strong> Soft, velvety, glossy microfiber finish.",
    pcs_backing_text: "<strong>Backing:</strong> Non-slip cotton base for secure placement on any floor.",
    pcs_pile_text: "<strong>Pile:</strong> Low pile height for effortless cleaning and daily maintenance.",
    pcs_finishing_text: "<strong>Finishing:</strong> Edges finished with a color-matched overlock stitch for a clean, durable edge.",
    pcs_safety_text: "<strong>Safety:</strong> 100% free of harmful substances — safe for children and pets. Hypoallergenic, no shedding fluff or hair.",
    pcs_care_title: "Care Instructions",
    pcs_care_text: "Easily machine washable. Wash using cold water on a gentle cycle. Avoid bleach and high heat drying to preserve color vibrancy and texture.",
    pcs_sizing_title: "Sizing &amp; Custom Dimensions",
    pcs_sizing_text: "Need a different size? We craft the perfect fit for any room — from 1.3 × 1.3 ft (40 × 40 cm) up to 6.5 × 16.4 ft (200 × 500 cm). Contact us for a custom order.",
    pcs_sizing_note: "Please note: as with all digitally printed textiles, final dimensions may vary by up to ±10% in line with international textile manufacturing standards. Colors may also appear slightly different depending on your screen calibration.",
    pcs_shipping_title: "Shipping &amp; Packaging",
    pcs_shipping_text1: "Every rug is shipped free of charge worldwide via express courier, securely wrapped in a durable, protective covering.",
    pcs_ship_europe: "Europe: 1–3 business days",
    pcs_ship_us: "US &amp; Canada: 2–4 business days",
    pcs_ship_rest: "Rest of the world: 2–5 business days",
    pcs_shipping_gift: "Ordering as a gift? Let us know in your order notes and we'll gift-wrap it at no extra cost.",
    share_label: "Share:",
    obt_title: "Often Bought Together",
    add_both_to_cart: "Add Both to Cart",
    you_may_also_like: "You May Also Like",

    // Collection page
    rugs_word: "rugs",
    filter_label: "Filter:",
    all_filter: "All",
    sort_featured: "Featured",
    sort_best_selling: "Best Selling",
    sort_newest: "Newest",
    sort_price_low: "Price: Low → High",
    sort_price_high: "Price: High → Low",
    // Filter system
    filter_btn: "Filter",
    filter_clear_all: "Clear all",
    filter_size: "Size",
    filter_size_small: "Small (40–90cm)",
    filter_size_medium: "Medium (100–160cm)",
    filter_size_large: "Large (160–230cm)",
    filter_size_xlarge: "XL (230cm+)",
    filter_theme: "Theme",
    filter_theme_movies: "Movies & TV",
    filter_theme_tapestry: "Tapestry",
    filter_theme_seasonal: "Seasonal",
    filter_theme_hobby: "Hobby & Lifestyle",
    filter_style: "Style",
    style_modern: "Modern",
    style_classic: "Classic",
    style_kids: "Kids & Fun",
    style_seasonal_s: "Seasonal",
    style_bold: "Bold & Colorful",
    style_minimal: "Minimal & Calm",
    prev_page: "← Prev",
    next_page: "Next →",
    no_products_found: "No products found in this collection.",
    browse_all_rugs: "Browse All Rugs",

    // Cart page
    your_cart: "Your Cart",
    order_summary: "Order Summary",
    subtotal: "Subtotal",
    items_word: "items",
    shipping_word: "Shipping",
    free_word: "FREE",
    continue_shopping: "Continue Shopping",
    secure_checkout: "🔒 Secure checkout",
    free_worldwide_shipping_emoji: "🚚 Free worldwide shipping",
    cart_empty_msg: "Your cart is empty",

    // Search page
    results_for: "results for",
    search_word: "Search",
    search_rugs_ph: "Search rugs...",
    no_results_found: "No results found for",
    try_different_term: "Try a different search term or",
    browse_all_rugs_lower: "browse all rugs",

    // 404
    page_not_found: "Page Not Found",
    page_not_found_msg: "The page you're looking for doesn't exist or has been moved.",
    go_home: "Go Home",
  },

  de: {
    cart: "Warenkorb",
    sign_in: "Anmelden",
    my_account: "Mein Konto",
    sign_out: "Abmelden",
    search_placeholder: "Teppiche suchen…",
    home: "Startseite",

    stat_models: "Teppichmodelle",
    stat_satisfaction: "Zufriedenheit",
    stat_countries: "Länder",
    scroll: "scrollen",

    explore: "Entdecken",
    nav_by_room: "Nach Raum",
    nav_by_theme: "Nach Thema",
    nav_best_sellers: "Bestseller",
    nav_round_rugs: "Runde Teppiche",
    round_label: "Rund",
    round_all: "Alle Runden Teppiche",
    shop_by_category: "Nach <em>Kategorie</em> einkaufen",
    browse_sub: "Durchstöbern Sie jeden Raum und jedes Thema — über 500 Teppiche warten auf Sie.",
    room_label: "Raum",
    theme_label: "Thema",
    room_living: "Wohnzimmer",
    room_bedroom: "Schlafzimmer",
    room_kids: "Kinderzimmer",
    theme_sports: "Sport & Fußball",
    theme_cars: "Autos & Formel 1",
    theme_anime: "Anime",
    theme_space: "Weltraum & Galaxie",
    theme_moody: "Stimmungsvoll & Ästhetisch",
    theme_abstract: "Abstrakt & Modern",
    shop_now: "Jetzt einkaufen →",

    featured: "Empfohlen",
    picked_for_you: "Für <em>Sie</em> ausgewählt",
    curated_sub: "Kuratierte Stücke, die unsere Kunden diese Saison am meisten lieben.",

    add_to_cart: "In den Warenkorb",
    sold_out: "Ausverkauft",
    best_seller: "Bestseller",
    sale: "Sale",
    new_badge: "Neu",
    adding_dots: "Wird hinzugefügt…",
    added_check: "Hinzugefügt ✓",
    error_word: "Fehler",

    ship_free_title: "Kostenloser Weltweiter Versand",
    ship_free_sub: "Kein Mindestbestellwert. Jedes Land.",
    ship_fast_title: "Schneller Versand",
    ship_fast_sub: "Versand innerhalb von 1–3 Werktagen",
    ship_secure_title: "Sicher &amp; Versichert",
    ship_secure_sub: "Jede Bestellung vollständig geschützt",
    ship_quality_title: "Premium-Qualität",
    ship_quality_sub: "Lebendige, farbechte Drucke",
    support: "Support",
    common_questions: "Häufige Fragen",
    faq_q1: "Wie lange dauert der Versand?",
    faq_a1: "Die meisten Bestellungen werden innerhalb von 1–3 Werktagen versandt. Die internationale Lieferung dauert je nach Standort in der Regel 7–14 Werktage. Sie erhalten einen Tracking-Link per E-Mail, sobald die Sendung versandt wurde.",
    faq_q2: "Versenden Sie in mein Land?",
    faq_a2: "Ja — wir versenden weltweit in jedes Land ohne Mindestbestellwert. Der Versand ist immer kostenlos, ohne Ausnahmen.",
    faq_q3: "Kann ich einen Teppich zurückgeben?",
    faq_a3: "Wir akzeptieren Rückgaben oder Erstattungen nur im Falle eines Herstellungs- oder Druckfehlers. Kontaktieren Sie uns mit Fotos innerhalb von 48 Stunden nach Lieferung.",
    faq_q4: "Wie verfolge ich meine Bestellung?",
    faq_a4: "Nach dem Versand erhalten Sie eine Tracking-E-Mail. Sie können auch auf der Website die Schaltfläche \"Bestellung verfolgen\" anklicken und Ihre Bestellnummer eingeben.",
    faq_q5: "Bieten Sie individuelle Größen an?",
    faq_a5: "Ja. Kontaktieren Sie uns über das untenstehende Formular mit Ihren gewünschten Maßen und Designvorstellungen. Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
    faq_q6: "Welche Zahlungsmethoden akzeptieren Sie?",
    faq_a6: "Wir akzeptieren alle gängigen Kredit- und Debitkarten (Visa, Mastercard) sowie digitale Geldbörsen. Alle Zahlungen werden sicher verarbeitet.",
    get_in_touch: "Kontakt",
    contact_us: "Kontaktieren Sie <em>Uns</em>",
    your_name: "Ihr Name",
    your_email: "Ihre E-Mail",
    select_topic: "Thema auswählen",
    order_question: "Frage zur Bestellung",
    return_exchange: "Rückgabe / Umtausch",
    custom_order: "Sonderbestellung",
    shipping_question: "Frage zum Versand",
    other: "Sonstiges",
    your_message: "Ihre Nachricht…",
    send_message: "Nachricht senden",
    thank_you_reply: "Vielen Dank! Wir antworten innerhalb von 24 Stunden.",
    response_24h: "Antwort innerhalb von 24 Stunden",

    my_cart: "Mein Warenkorb",
    track_order: "Bestellung verfolgen",
    all_rugs: "Alle Teppiche",

    track_your_order: "Bestellung verfolgen",
    track_your_order_sub: "Geben Sie Ihre Bestelldetails ein, um den Lieferstatus zu prüfen",
    order_number_ph: "Bestellnummer (z.B. KAZE-2025-0001)",
    email_address_ph: "E-Mail-Adresse",
    need_help: "Brauchen Sie Hilfe?",
    contact_us_arrow: "Kontaktieren Sie uns →",

    total: "Gesamt",
    free_worldwide_shipping: "Kostenloser weltweiter Versand",
    checkout_arrow: "Zur Kasse →",
    added_to_cart: "Zum Warenkorb hinzugefügt!",
    might_also_like: "Das könnte Ihnen auch gefallen:",
    finding_recommendations: "Empfehlungen werden gesucht…",
    view_cart_arrow: "Warenkorb ansehen →",

    footer_tagline: "Handgefertigte &amp; moderne Teppiche.<br>Kostenloser weltweiter Versand.",
    about_us: "Über Uns",
    contact: "Kontakt",
    privacy_policy: "Datenschutzrichtlinie",
    terms_of_service: "Nutzungsbedingungen",
    refund_policy: "Rückerstattungsrichtlinie",
    shipping_policy: "Versandrichtlinie",
    seo_title: "Moderne Teppiche & Läufer für Ihr Zuhause",
    seo_p1: "KazeHaus entwirft moderne Teppiche, Läufer und waschbare Kunstteppiche, die jedem Raum Charakter verleihen — Wohnzimmer, Schlafzimmer, Küche, Flur und Kinderzimmer. Von abstrakten und Vintage-Mustern bis zu Anime- und Pop-Culture-Designs wird jeder Teppich auf Bestellung gefertigt, mit rutschfester Rückseite und pflegeleichten, waschbaren Materialien.",
    seo_p2: "Wir liefern weltweit — in die USA, nach Kanada, Großbritannien, Deutschland, Spanien und darüber hinaus — mit kostenlosem Versand in nur 3–5 Werktagen. Ob großer Wohnzimmerteppich, schmaler Läufer für den Flur oder Statement-Piece fürs Gaming-Zimmer: KazeHaus hat das passende Design für Sie.",
    distance_sales: "Fernabsatzvertrag",
    secure_payment_with: "Sichere Zahlung",
    all_rights_reserved: "Alle Rechte vorbehalten.",
    free_shipping: "Kostenloser Versand",
    secure_payment: "Sichere Zahlung",

    trust_free_shipping: "✦ Kostenloser weltweiter Versand",
    trust_ships_days: "✦ Versand in 1–3 Tagen",
    buy_now: "Jetzt kaufen",
    meta_material: "Material",
    meta_size: "Größe",
    meta_origin: "Herkunft",
    meta_care: "Pflege",
    pcs_material_title: "Material &amp; Qualität",
    pcs_material_text: "<strong>Material:</strong> Premium-Polyester-Mikrofaser mit fotorealistischem Digitaldruck — Farben bleiben lebendig und verblassen nicht.",
    pcs_surface_text: "<strong>Oberfläche:</strong> Weiches, samtiges, glänzendes Mikrofaser-Finish.",
    pcs_backing_text: "<strong>Rückseite:</strong> Rutschfeste Baumwollbasis für sicheren Halt auf jedem Boden.",
    pcs_pile_text: "<strong>Flor:</strong> Niedrige Florhöhe für mühelose Reinigung und tägliche Pflege.",
    pcs_finishing_text: "<strong>Verarbeitung:</strong> Kanten mit farblich abgestimmtem Overlock-Stich für eine saubere, langlebige Kante versehen.",
    pcs_safety_text: "<strong>Sicherheit:</strong> 100% frei von Schadstoffen — sicher für Kinder und Haustiere. Hypoallergen, ohne Fasern oder Haare zu verlieren.",
    pcs_care_title: "Pflegehinweise",
    pcs_care_text: "Einfach maschinenwaschbar. Mit kaltem Wasser im Schonwaschgang waschen. Bleichmittel und hohe Trocknertemperaturen vermeiden, um Farbintensität und Textur zu erhalten.",
    pcs_sizing_title: "Größen &amp; Sonderanfertigungen",
    pcs_sizing_text: "Brauchen Sie eine andere Größe? Wir fertigen die perfekte Passform für jeden Raum — von 1,3 × 1,3 ft (40 × 40 cm) bis 6,5 × 16,4 ft (200 × 500 cm). Kontaktieren Sie uns für eine Sonderbestellung.",
    pcs_sizing_note: "Bitte beachten Sie: Wie bei allen digital bedruckten Textilien können die endgültigen Maße gemäß internationalen Textilstandards um bis zu ±10% abweichen. Farben können je nach Bildschirmkalibrierung leicht abweichen.",
    pcs_shipping_title: "Versand &amp; Verpackung",
    pcs_shipping_text1: "Jeder Teppich wird weltweit kostenlos per Express-Kurier versandt, sicher in einer langlebigen Schutzhülle verpackt.",
    pcs_ship_europe: "Europa: 1–3 Werktage",
    pcs_ship_us: "USA &amp; Kanada: 2–4 Werktage",
    pcs_ship_rest: "Rest der Welt: 2–5 Werktage",
    pcs_shipping_gift: "Bestellen Sie als Geschenk? Teilen Sie uns dies in Ihren Bestellnotizen mit, und wir verpacken es kostenlos als Geschenk.",
    share_label: "Teilen:",
    obt_title: "Häufig zusammen gekauft",
    add_both_to_cart: "Beides in den Warenkorb",
    you_may_also_like: "Das könnte Ihnen auch gefallen",

    rugs_word: "Teppiche",
    filter_label: "Filter:",
    all_filter: "Alle",
    sort_featured: "Empfohlen",
    sort_best_selling: "Bestseller",
    sort_newest: "Neueste",
    sort_price_low: "Preis: Niedrig → Hoch",
    sort_price_high: "Preis: Hoch → Niedrig",
    // Filter system
    filter_btn: "Filtern",
    filter_clear_all: "Alle löschen",
    filter_size: "Größe",
    filter_size_small: "Klein (40–90cm)",
    filter_size_medium: "Mittel (100–160cm)",
    filter_size_large: "Groß (160–230cm)",
    filter_size_xlarge: "XL (230cm+)",
    filter_theme: "Thema",
    filter_theme_movies: "Filme & TV",
    filter_theme_tapestry: "Wandteppich",
    filter_theme_seasonal: "Saisonal",
    filter_theme_hobby: "Hobby & Lebensstil",
    filter_style: "Stil",
    style_modern: "Modern",
    style_classic: "Klassisch",
    style_kids: "Kinder & Spaß",
    style_seasonal_s: "Saisonal",
    style_bold: "Kräftig & Bunt",
    style_minimal: "Minimal & Ruhig",
    prev_page: "← Zurück",
    next_page: "Weiter →",
    no_products_found: "Keine Produkte in dieser Kollektion gefunden.",
    browse_all_rugs: "Alle Teppiche durchsuchen",

    your_cart: "Ihr Warenkorb",
    order_summary: "Bestellübersicht",
    subtotal: "Zwischensumme",
    items_word: "Artikel",
    shipping_word: "Versand",
    free_word: "KOSTENLOS",
    continue_shopping: "Weiter einkaufen",
    secure_checkout: "🔒 Sicherer Checkout",
    free_worldwide_shipping_emoji: "🚚 Kostenloser weltweiter Versand",
    cart_empty_msg: "Ihr Warenkorb ist leer",

    results_for: "Ergebnisse für",
    search_word: "Suchen",
    search_rugs_ph: "Teppiche suchen...",
    no_results_found: "Keine Ergebnisse gefunden für",
    try_different_term: "Versuchen Sie einen anderen Suchbegriff oder",
    browse_all_rugs_lower: "alle Teppiche durchsuchen",

    page_not_found: "Seite nicht gefunden",
    page_not_found_msg: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
    go_home: "Zur Startseite",
  },

  es: {
    cart: "Carrito",
    sign_in: "Iniciar sesión",
    my_account: "Mi cuenta",
    sign_out: "Cerrar sesión",
    search_placeholder: "Buscar alfombras…",
    home: "Inicio",

    stat_models: "Modelos de Alfombras",
    stat_satisfaction: "Satisfacción",
    stat_countries: "Países",
    scroll: "desplazar",

    explore: "Explorar",
    nav_by_room: "Por Habitación",
    nav_by_theme: "Por Tema",
    nav_best_sellers: "Más Vendidos",
    nav_round_rugs: "Alfombras Redondas",
    round_label: "Redonda",
    round_all: "Todas las Alfombras Redondas",
    shop_by_category: "Comprar por <em>Categoría</em>",
    browse_sub: "Explora cada habitación y tema — más de 500 alfombras te esperan.",
    room_label: "Habitación",
    theme_label: "Tema",
    room_living: "Sala de Estar",
    room_bedroom: "Dormitorio",
    room_kids: "Habitación Infantil",
    theme_sports: "Deportes y Fútbol",
    theme_cars: "Autos y Fórmula 1",
    theme_anime: "Anime",
    theme_space: "Espacio y Galaxia",
    theme_moody: "Atmosférico y Estético",
    theme_abstract: "Abstracto y Moderno",
    shop_now: "Comprar ahora →",

    featured: "Destacado",
    picked_for_you: "Seleccionado para <em>Ti</em>",
    curated_sub: "Piezas seleccionadas que nuestros clientes más aman esta temporada.",

    add_to_cart: "Añadir al Carrito",
    sold_out: "Agotado",
    best_seller: "Más Vendido",
    sale: "Oferta",
    new_badge: "Nuevo",
    adding_dots: "Añadiendo…",
    added_check: "Añadido ✓",
    error_word: "Error",

    ship_free_title: "Envío Mundial Gratuito",
    ship_free_sub: "Sin mínimos. Cualquier país.",
    ship_fast_title: "Envío Rápido",
    ship_fast_sub: "Se envía en 1–3 días hábiles",
    ship_secure_title: "Seguro y Protegido",
    ship_secure_sub: "Cada pedido totalmente protegido",
    ship_quality_title: "Calidad Premium",
    ship_quality_sub: "Impresiones vibrantes y resistentes al desgaste",
    support: "Soporte",
    common_questions: "Preguntas Frecuentes",
    faq_q1: "¿Cuánto tiempo tarda el envío?",
    faq_a1: "La mayoría de los pedidos se envían dentro de 1–3 días hábiles. La entrega internacional suele tardar entre 7 y 14 días hábiles según tu ubicación. Recibirás un enlace de seguimiento por correo electrónico una vez enviado.",
    faq_q2: "¿Envían a mi país?",
    faq_a2: "Sí — enviamos a todos los países del mundo sin pedido mínimo. El envío siempre es gratuito, sin excepciones.",
    faq_q3: "¿Puedo devolver una alfombra?",
    faq_a3: "Aceptamos devoluciones o reembolsos solo en caso de error de fabricación o impresión. Contáctanos con fotos dentro de las 48 horas posteriores a la entrega.",
    faq_q4: "¿Cómo rastreo mi pedido?",
    faq_a4: "Una vez enviado, recibirás un correo electrónico de seguimiento. También puedes hacer clic en el botón \"Rastrear Pedido\" en esta página e ingresar tu número de pedido.",
    faq_q5: "¿Hacen tamaños personalizados?",
    faq_a5: "Sí. Contáctanos a través del formulario a continuación con tus dimensiones requeridas y preferencias de diseño. Te responderemos dentro de 24 horas.",
    faq_q6: "¿Qué métodos de pago aceptan?",
    faq_a6: "Aceptamos todas las principales tarjetas de crédito y débito (Visa, Mastercard), así como billeteras digitales. Todos los pagos se procesan de forma segura.",
    get_in_touch: "Contáctanos",
    contact_us: "Contáctanos <em>Ahora</em>",
    your_name: "Tu nombre",
    your_email: "Tu correo electrónico",
    select_topic: "Selecciona un tema",
    order_question: "Pregunta sobre pedido",
    return_exchange: "Devolución / Cambio",
    custom_order: "Pedido personalizado",
    shipping_question: "Pregunta sobre envío",
    other: "Otro",
    your_message: "Tu mensaje…",
    send_message: "Enviar Mensaje",
    thank_you_reply: "¡Gracias! Responderemos dentro de 24 horas.",
    response_24h: "Respuesta dentro de 24 horas",

    my_cart: "Mi Carrito",
    track_order: "Rastrear Pedido",
    all_rugs: "Todas las Alfombras",

    track_your_order: "Rastrea tu Pedido",
    track_your_order_sub: "Ingresa los detalles de tu pedido para verificar el estado de la entrega",
    order_number_ph: "Número de pedido (ej. KAZE-2025-0001)",
    email_address_ph: "Dirección de correo electrónico",
    need_help: "¿Necesitas ayuda?",
    contact_us_arrow: "Contáctanos →",

    total: "Total",
    free_worldwide_shipping: "Envío mundial gratuito",
    checkout_arrow: "Pagar →",
    added_to_cart: "¡Añadido al carrito!",
    might_also_like: "También te puede gustar:",
    finding_recommendations: "Buscando recomendaciones…",
    view_cart_arrow: "Ver Carrito →",

    footer_tagline: "Alfombras artesanales &amp; modernas.<br>Envío mundial gratuito.",
    about_us: "Sobre Nosotros",
    contact: "Contacto",
    privacy_policy: "Política de Privacidad",
    terms_of_service: "Términos de Servicio",
    refund_policy: "Política de Reembolso",
    shipping_policy: "Política de Envío",
    seo_title: "Alfombras modernas y alfombras de pasillo para tu hogar",
    seo_p1: "KazeHaus diseña alfombras modernas, alfombras de pasillo y alfombras artísticas lavables que aportan carácter a cada habitación: salón, dormitorio, cocina, pasillo y habitaciones infantiles. Desde estampados abstractos y vintage hasta diseños de anime y cultura pop, cada alfombra se fabrica bajo pedido con base antideslizante y materiales lavables de fácil cuidado.",
    seo_p2: "Enviamos a todo el mundo — Estados Unidos, Canadá, Reino Unido, Alemania, España y más — con entrega gratuita en solo 3–5 días laborables. Ya busques una alfombra grande para el salón, una alfombra de pasillo estrecha o una pieza única para tu sala gaming, KazeHaus tiene un diseño para ti.",
    distance_sales: "Contrato de Venta a Distancia",
    secure_payment_with: "Pago Seguro",
    all_rights_reserved: "Todos los derechos reservados.",
    free_shipping: "Envío Gratuito",
    secure_payment: "Pago Seguro",

    trust_free_shipping: "✦ Envío mundial gratuito",
    trust_ships_days: "✦ Se envía en 1–3 días",
    buy_now: "Comprar Ahora",
    meta_material: "Material",
    meta_size: "Tamaño",
    meta_origin: "Origen",
    meta_care: "Cuidado",
    pcs_material_title: "Material &amp; Calidad",
    pcs_material_text: "<strong>Material:</strong> Microfibra de poliéster premium con impresión digital fotorrealista — los colores se mantienen vibrantes sin desteñirse con el tiempo.",
    pcs_surface_text: "<strong>Superficie:</strong> Acabado suave, aterciopelado y brillante de microfibra.",
    pcs_backing_text: "<strong>Base:</strong> Base de algodón antideslizante para una colocación segura en cualquier suelo.",
    pcs_pile_text: "<strong>Pelo:</strong> Altura de pelo bajo para una limpieza sin esfuerzo y mantenimiento diario.",
    pcs_finishing_text: "<strong>Acabado:</strong> Bordes terminados con una costura overlock a juego para un borde limpio y duradero.",
    pcs_safety_text: "<strong>Seguridad:</strong> 100% libre de sustancias nocivas — segura para niños y mascotas. Hipoalergénica, sin pelusa ni pelo.",
    pcs_care_title: "Instrucciones de Cuidado",
    pcs_care_text: "Fácilmente lavable a máquina. Lavar con agua fría en ciclo suave. Evitar el uso de blanqueador y secado a alta temperatura para preservar el color y la textura.",
    pcs_sizing_title: "Tamaños &amp; Dimensiones Personalizadas",
    pcs_sizing_text: "¿Necesitas un tamaño diferente? Creamos el ajuste perfecto para cualquier habitación — desde 1.3 × 1.3 ft (40 × 40 cm) hasta 6.5 × 16.4 ft (200 × 500 cm). Contáctanos para un pedido personalizado.",
    pcs_sizing_note: "Tenga en cuenta: como con todos los textiles impresos digitalmente, las dimensiones finales pueden variar hasta ±10% según los estándares internacionales de fabricación textil. Los colores también pueden variar ligeramente según la calibración de su pantalla.",
    pcs_shipping_title: "Envío &amp; Embalaje",
    pcs_shipping_text1: "Cada alfombra se envía de forma gratuita a nivel mundial mediante mensajería exprés, empaquetada de forma segura en una cubierta protectora duradera.",
    pcs_ship_europe: "Europa: 1–3 días hábiles",
    pcs_ship_us: "EE.UU. &amp; Canadá: 2–4 días hábiles",
    pcs_ship_rest: "Resto del mundo: 2–5 días hábiles",
    pcs_shipping_gift: "¿Es un pedido de regalo? Indícanoslo en las notas de tu pedido y lo envolveremos como regalo sin costo adicional.",
    share_label: "Compartir:",
    obt_title: "Comprados Juntos Frecuentemente",
    add_both_to_cart: "Añadir Ambos al Carrito",
    you_may_also_like: "También Te Puede Gustar",

    rugs_word: "alfombras",
    filter_label: "Filtrar:",
    all_filter: "Todo",
    sort_featured: "Destacado",
    sort_best_selling: "Más Vendidos",
    sort_newest: "Más Reciente",
    sort_price_low: "Precio: Bajo → Alto",
    sort_price_high: "Precio: Alto → Bajo",
    // Filter system
    filter_btn: "Filtrar",
    filter_clear_all: "Borrar todo",
    filter_size: "Tamaño",
    filter_size_small: "Pequeño (40–90cm)",
    filter_size_medium: "Mediano (100–160cm)",
    filter_size_large: "Grande (160–230cm)",
    filter_size_xlarge: "XL (230cm+)",
    filter_theme: "Tema",
    filter_theme_movies: "Películas y TV",
    filter_theme_tapestry: "Tapiz",
    filter_theme_seasonal: "Estacional",
    filter_theme_hobby: "Aficiones y Estilo de Vida",
    filter_style: "Estilo",
    style_modern: "Moderno",
    style_classic: "Clásico",
    style_kids: "Niños y Diversión",
    style_seasonal_s: "Estacional",
    style_bold: "Audaz y Colorido",
    style_minimal: "Minimal y Tranquilo",
    prev_page: "← Anterior",
    next_page: "Siguiente →",
    no_products_found: "No se encontraron productos en esta colección.",
    browse_all_rugs: "Ver Todas las Alfombras",

    your_cart: "Tu Carrito",
    order_summary: "Resumen del Pedido",
    subtotal: "Subtotal",
    items_word: "artículos",
    shipping_word: "Envío",
    free_word: "GRATIS",
    continue_shopping: "Seguir Comprando",
    secure_checkout: "🔒 Pago seguro",
    free_worldwide_shipping_emoji: "🚚 Envío mundial gratuito",
    cart_empty_msg: "Tu carrito está vacío",

    results_for: "resultados para",
    search_word: "Buscar",
    search_rugs_ph: "Buscar alfombras...",
    no_results_found: "No se encontraron resultados para",
    try_different_term: "Intenta un término de búsqueda diferente o",
    browse_all_rugs_lower: "ver todas las alfombras",

    page_not_found: "Página No Encontrada",
    page_not_found_msg: "La página que buscas no existe o ha sido movida.",
    go_home: "Ir al Inicio",
  }
};

/* ─────────────────────────────────────
   TRANSLATION ENGINE
───────────────────────────────────── */
(function () {
  const STORAGE_KEY = 'carina_lang';

  function getLang() {
    try { return localStorage.getItem(STORAGE_KEY) || 'en'; } catch { return 'en'; }
  }
  function setLang(lang) {
    try { localStorage.setItem(STORAGE_KEY, lang); } catch {}
  }

  function applyTranslations(lang) {
    const dict = window.CARINA_I18N[lang] || window.CARINA_I18N.en;

    // Text content (innerHTML to support <em>/<strong> in dictionary)
    document.querySelectorAll('[data-i18n]').forEach(el => {
      const key = el.getAttribute('data-i18n');
      if (dict[key] !== undefined) el.innerHTML = dict[key];
    });

    // Placeholder attributes
    document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
      const key = el.getAttribute('data-i18n-placeholder');
      if (dict[key] !== undefined) el.setAttribute('placeholder', dict[key].replace(/<[^>]*>/g, ''));
    });

    document.documentElement.setAttribute('lang', lang);
  }

  function syncLangButtons(activeLang) {
    document.querySelectorAll('.lang-btn').forEach(b => {
      const isMatch = b.dataset.lang === activeLang;
      b.classList.toggle('active', isMatch);
      b.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
    });
  }

  function initLangSwitcher() {
    const lang = getLang();
    applyTranslations(lang);
    syncLangButtons(lang);

    // Tek seferlik event delegation — duplicate listener sorunu yok
    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.lang-btn');
      if (!btn) return;
      const newLang = btn.dataset.lang;
      if (!newLang) return;
      setLang(newLang);
      syncLangButtons(newLang);
      applyTranslations(newLang);
      document.dispatchEvent(new CustomEvent('carina:langchange', { detail: { lang: newLang } }));
    });
  }

  document.addEventListener('DOMContentLoaded', initLangSwitcher);

  // Expose helper for main.js to use when building dynamic content (cart items, upsell cards)
  window.carinaT = function (key) {
    const lang = getLang();
    const dict = window.CARINA_I18N[lang] || window.CARINA_I18N.en;
    return dict[key] !== undefined ? dict[key] : (window.CARINA_I18N.en[key] || key);
  };
  window.carinaGetLang = getLang;
})();
